import { createSlice } from 'common/modules/create-slice';
import { brandSchemaData, BrandSchemaData } from './data';

export interface BrandSchemaState {
    data: Record<number, BrandSchemaData>;
}

const initialState: BrandSchemaState = {
    data: brandSchemaData,
};

const brandSchemaSlice = createSlice(initialState, 'brandSchema');

// Future: Add actions to update brand schema data dynamically from backend
// export const updateBrandSchema = brandSchemaSlice.configureAction(
//     'UPDATE_BRAND_SCHEMA',
//     (brandSchemaData: BrandSchemaData) => (state: BrandSchemaState) => ({
//         ...state,
//         data: {
//             ...state.data,
//             [brandSchemaData.brandId]: brandSchemaData,
//         },
//     })
// );

export const brandSchemaReducer = brandSchemaSlice.reducer;
